import { Box, Button, Flex, Image, Input, Text } from '@chakra-ui/react'
import { useGoogleLogin } from '@react-oauth/google'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { FormField } from '../../components/FormField'
import { useAppToast } from '../../helpers'
import AuthService from '../../services/Auth/AuthService'
import styles from './Login.module.css'

export default function LoginPage() {
  const actualDate = new Date()
  const actualYear = actualDate.getFullYear()
  const [loginError, setLoginError] = useState('')
  const [form, setForm] = useState({ email: '', password: '' })
  const navigate = useNavigate()
  const authService = new AuthService()
  const toast = useAppToast()
  const [logging, setLogging] = useState(false)

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => makeLogin(codeResponse),
    // O popup do Google falhar (fechado, bloqueado, conta recusada) deixava a tela igual à de
    // quem nem clicou: o botão voltava ao normal e nada era dito.
    onError: (error) => toast.error('Falha ao entrar com o Google', error)
  })

  // Deep links (e.g. kanban card links in e-mails) store the intended route
  // before redirecting to /login; honor it after a successful login.
  const navigateAfterLogin = () => {
    const redirect = sessionStorage.getItem('redirect_after_login')
    sessionStorage.removeItem('redirect_after_login')
    navigate(redirect && redirect.startsWith('/') ? redirect : '/home')
  }

  const handleLogin = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    setLogging(true)

    authService
      .auth(form)
      .then((response) => {
        localStorage.setItem('token', response.data.token)
        localStorage.setItem('user', JSON.stringify(response.data.user))

        navigateAfterLogin()
      })
      .catch(() => {
        toast.error('Falha ao realizar login')

        setLogging(false)
      })
  }

  const makeLogin = async (response: { access_token: string }) => {
    try {
      setLogging(true)
      const auth = await authService.authGoogle({ access_token: response.access_token })

      localStorage.setItem('token', auth.data.token)
      localStorage.setItem('user', JSON.stringify(auth.data.user))

      navigateAfterLogin()
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setLogging(false)
      setLoginError(e.response.data.error)
    }
  }

  useEffect(() => {
    if (localStorage.getItem('token')) {
      navigateAfterLogin()
    } else {
      setLogging(false)
    }
  }, [])

  return (
    <>
      <Box className={styles.login}>
        <Flex minH="100vh" w="100%" direction="column" align="center" justify="center">
          <Image src="/img/logo.png" alt="ABRA" />
          {/* O grid do Bootstrap repetia `col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4`
              em cada campo só para dizer "uma coluna centralizada": aqui é um maxW só. */}
          <Box w="100%" maxW={{ base: '100%', md: '480px', lg: '380px' }} px={3}>
            <form onSubmit={handleLogin}>
              <FormField label="E-mail" htmlFor="email" mb={3}>
                <Input
                  id="email"
                  placeholder="E-mail"
                  type="email"
                  color="white"
                  value={form.email}
                  onChange={(e) => setForm({ ...form, email: e.target.value })}
                  isDisabled={logging}
                />
              </FormField>
              <FormField label="Senha" htmlFor="password" mb={3}>
                <Input
                  id="password"
                  placeholder="Senha"
                  type="password"
                  color="white"
                  value={form.password}
                  onChange={(e) => setForm({ ...form, password: e.target.value })}
                  isDisabled={logging}
                />
              </FormField>
              <Button colorScheme="magenta" mt={2} type="submit" width="100%" isDisabled={logging}>
                Acessar
              </Button>
            </form>

            <Button
              colorScheme="whiteAlpha"
              mt={2}
              type="button"
              onClick={() => login()}
              variant="outline"
              width="100%"
              isDisabled={logging}
            >
              <Image src="/img/google-icon.png" alt="Google" width="20px" height="20px" marginEnd={2} />
              Acessar com o Google
            </Button>

            {loginError && (
              <Text textAlign="center" mt={2} color="white">
                {loginError}
              </Text>
            )}
          </Box>
        </Flex>

        <Box as="footer" className={styles.loginFooter}>
          © {actualYear} All Right Reserved. ABRA - Academia Brasileira de Arte.
        </Box>
      </Box>
    </>
  )
}
